import React from 'react';

import { BaseButton } from '@components/primitives';
import { SimpleCircleSpinner } from '@components/spinners';

import type { AcceptButtonProperties } from './ActionButton.types';

export const ActionButton: React.FC<AcceptButtonProperties> = ({
  dataTest = 'action_button',
  onClick,
  isSubmitting,
  isDisabled,
  color,
  label,
  type = 'button',
  variant = 'contained',
  size = 'large',
  sx,
  spinnerSize = '20',
}) => {
  const handleClick = React.useCallback(() => {
    onClick?.();
  }, [onClick]);
  return (
    <BaseButton
      dataTest={dataTest}
      color={color}
      variant={variant}
      type={type}
      onClick={handleClick}
      disabled={isSubmitting || isDisabled}
      size={size}
      startIcon={
        <SimpleCircleSpinner size={spinnerSize} isLoading={isSubmitting} />
      }
      sx={{ width: '100%', ...sx }}
    >
      {isSubmitting
        ? (label ?? 'Отправляется...')
        : (label ?? 'Отправить')}
    </BaseButton>
  );
};
